const GENERIC = 'Failed to register pet. Please try again.';
const NETWORK =
  'Connection lost during registration. Check your dashboard — your draft may be saved. Please try again.';

type ApiError = {
  message?: unknown;
  response?: {
    data?: {
      detail?: unknown;
      message?: unknown;
    };
  };
};

function asApiError(error: unknown): ApiError | null {
  if (!error || typeof error !== 'object') return null;
  return error as ApiError;
}

/** FastAPI puts the resident-facing reason on `detail`, not `message`. */
export function detailFromApiError(error: unknown): string | null {
  const data = asApiError(error)?.response?.data;
  if (!data) return null;
  if (typeof data.detail === 'string' && data.detail.trim()) return data.detail.trim();
  if (typeof data.message === 'string' && data.message.trim()) return data.message.trim();
  return null;
}

export function isRegistrationNetworkError(error: unknown): boolean {
  const err = asApiError(error);
  if (!err || err.response) return false;
  const message = String(err.message || '');
  return message === 'Network Error' || /network|Failed to fetch/i.test(message);
}

/** Pull the server reason out of registerPets' wrapped Error message. */
export function unwrapRegistrationDetail(message: string): string | null {
  const match = message.match(/Failed to register [^:\n]+:\s*([^\n]+)/);
  if (!match) return null;
  const reason = match[1].trim();
  if (!reason) return null;
  if (/request failed with status code \d+/i.test(reason)) return null;
  if (/^network error$/i.test(reason)) return null;
  return reason;
}

export function registrationToastMessage(error: unknown): string {
  if (isRegistrationNetworkError(error)) return NETWORK;
  const detail = detailFromApiError(error);
  if (detail) return detail;
  if (error instanceof Error) {
    const wrapped = unwrapRegistrationDetail(error.message);
    if (wrapped) return wrapped;
  }
  return GENERIC;
}
